import React, { useState } from 'react'

import IconButton from '../../elements/IconButton'
import Button from '../../elements/Button'
import TextInput from '../../elements/TextInput'

const Main = (props) => {
    const [bonusAmount, setBonusAmount] = useState('')

    return (
        <div style={{width: '360px', height: 'auto', display: 'flex', flexDirection: 'column'}}>
            <div style={{flexBasis: '10%', display: 'flex', flexDirection: 'row'}}>
                <span style={{fontWeight: '500', fontSize: '20px', flexBasis: '99%'}}>Custom Pay System Rate</span>
                <IconButton img={false} colors={props.colors} Style={{borderRadius: '3px', backgroundColor: props.colors.border, width: '24px'}} size="16px">
                    <div onClick={props.setIsOpen} style={{paddingLeft: '3px', paddingRight: '3px'}}><span onClick={props.setIsOpen}>x</span></div>
                </IconButton>
            </div>
            <div style={{flexBasis: '90%', display: 'flex', flexDirection: 'column'}}>
                <TextInput
                    colors={props.colors}
                    data={bonusAmount}
                    onChange={(value) => setBonusAmount(value)}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                            e.preventDefault()
                            props.handlePaySystemChange(props.selectedWeekNum, {label: 'Custom', value: 'Custom', amount: bonusAmount}, true)
                        }
                    }}
                    Style={{marginTop: '15px'}}
                ></TextInput>
            </div>
            <Button colors={props.colors} onClick={() => props.handlePaySystemChange(props.selectedWeekNum, {label: 'Custom', value: 'Custom', amount: bonusAmount}, true)} Style={{backgroundColor: props.colors.primary, color: props.colors.fontInvert, marginTop: '10px'}}>Save</Button>
        </div>
    )
}

export default Main
